"use strict";

require("./..\\..\\..\\bower_components\\iCheck\\icheck.min.js");

module.exports = function () {
	$('[icheck]').iCheck().on('ifChanged', function () {
		$(this).trigger('change');
	});
};